import { Outlet } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { LogOut, Warehouse } from 'lucide-react';
import useAuthStore from '@/stores/authStore';

// Depo çalışanı için ultra-basit tam-ekran mobil layout — cockpit/sidebar YOK
export default function WarehouseShell() {
  const { t } = useTranslation('warehouse');
  const { user, logout } = useAuthStore();
  const name = [user?.firstName, user?.lastName].filter(Boolean).join(' ') || t('shell.title', 'Lager');
  return (
    <div className="flex min-h-screen flex-col bg-slate-50">
      <header className="sticky top-0 z-20 flex items-center justify-between bg-[#0F99FD] px-4 py-4 text-white shadow-md">
        <div className="flex items-center gap-2.5">
          <Warehouse className="h-7 w-7" />
          <div className="leading-tight">
            <div className="text-lg font-extrabold">{t('shell.title', 'Lager')}</div>
            <div className="text-xs text-white/80">{name}</div>
          </div>
        </div>
        <button
          onClick={() => logout()}
          className="flex items-center gap-1.5 rounded-xl bg-white/15 px-3.5 py-2.5 text-sm font-bold transition hover:bg-white/25"
        >
          <LogOut className="h-4 w-4" /> {t('shell.logout', 'Abmelden')}
        </button>
      </header>
      <main className="mx-auto w-full max-w-2xl flex-1 px-3 py-3">
        <Outlet />
      </main>
    </div>
  );
}
